// extracted by mini-css-extract-plugin
module.exports = {"facet":"BigFiveFacet_facet__1hRw9","header":"BigFiveFacet_header__3rA6O","title":"BigFiveFacet_title__1TbOY","description":"BigFiveFacet_description__2uavP"};